import { DataContext } from "../../helper/HelperOne"
import NavBar from "../nav_bar/Navbar"
import { useState } from "react"
import SalesOrderList from "./SalesOrderList"

const SalesOrder = () => {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)

    return (
         <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<SalesOrderList/>}
                menuId={26}
            />
        </DataContext.Provider>
    )
}

export default SalesOrder